export const PDF_FONTS = {
  primary: 'helvetica',
  secondary: 'times',
  size: {
    title: 28,
    heading: 22,  // Increased from 20 for better hierarchy
    subheading: 18, // Increased from 16
    body: 12,
    small: 10,
    tiny: 8,
    // New sizes for better typographic control
    xlarge: 20,
    large: 16,
    medium: 14
  },
  weight: {
    normal: 'normal',
    bold: 'bold',
    // Additional weights if your PDF generator supports them
    light: 'light',
    semibold: 'semibold'
  },
  lineHeight: {
    title: 1.1,
    heading: 1.2,
    subheading: 1.3,
    body: 1.4,  // Better readability for body text
    small: 1.3
  }
} as const;

export const PDF_LAYOUT = {
  margins: {
    top: 20,
    left: 15,  // Reduced from 25 for more content space
    right: 15,
    bottom: 15,
    // Symmetrical margins by default
    gutter: 10  // For multi-column layouts
  },
  spacing: {
    section: 12,  // Increased from 20 for better visual separation
    subsection: 10,
    paragraph: 8,  // Increased from 12
    line: 4,  // Increased from 8
    small: 2,  // Increased from 4
    // New spacing options
    xlarge: 20,
    large: 16,
    medium: 12
  },
  chart: {
    width: 160,
    height: 120,  // Increased from 100 for better visibility
    barHeight: 10,  // Increased from 8
    maxBarWidth: 140,  // Increased from 120
    padding: {
      top: 10,
      bottom: 15,
      left: 20,
      right: 15
    },
    labelOffset: 8
  },
  // New layout properties
  page: {
    width: 210,  // Standard A4 width in mm
    height: 297   // Standard A4 height in mm
  },
  grid: {
    column: 12,
    gutter: 8
  },
  // Visual elements
  border: {
    width: 0.5,
    radius: 4
  },
  // New responsive breakpoints (in mm)
  breakpoints: {
    small: 100,
    medium: 150,
    large: 200
  }
} as const;

// Additional export for color palette
export const PDF_COLORS = {
  primary: '#2C3E50',
  secondary: '#E74C3C',
  accent: '#3498DB',
  text: {
    dark: '#2C3E50',
    light: '#FFFFFF',
    body: '#333333',
    muted: '#95A5A6'
  },
  background: {
    light: '#FFFFFF',
    dark: '#F8F9FA',
    highlight: '#EBF5FB'
  },
  chart: {
    primary: '#3498DB',
    secondary: '#E74C3C',
    tertiary: '#2ECC71',
    quaternary: '#F39C12'
  }
} as const;